import { isMenu } from "@bloomreach/spa-sdk";
import { getUrl } from "./get-url.js";
function createMenu(menu, page) {
  if (!isMenu(menu)) return [];
  return mapToMenu(menu.getItems(), page);
}
function mapToMenu(items, page) {
  return items.map((item) => {
    const link = item.getLink();
    const menuItem = {
      link: {
        ...link,
        href: parseHref(link, page) ?? "",
        type: link?.type === "internal" ? "internal" : "external"
      },
      parameters: item.getParameters(),
      childMenuItems: mapToMenu(item.getChildren(), page),
      label: item.getName()
    };
    return menuItem;
  });
}
function parseHref(link, page) {
  if (link && page) {
    return getUrl(link.href, page);
  }
}
export {
  createMenu,
  mapToMenu,
  parseHref
};
//# sourceMappingURL=create-menu.js.map
